import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=026a7a08&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('026a7a08')) {
      api.createRecord('026a7a08', component.options)
    } else {
      api.reload('026a7a08', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=026a7a08&", function () {
      api.rerender('026a7a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Error.vue"
export default component.exports